import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['filterButton', 'totalCount']

  connect() {
    this.selectedFilter = 'all';
    this.filterStories();
    // if stories-hero missing from page, make header fixed with background
    if (!document.querySelector('.stories-hero')) {
      document.body.classList.add('-page-scrolling');
      document.body.classList.add('body__generic--details');
      document.querySelector('#content').style.paddingTop = '50px';
    }
  }

  filter({ currentTarget: item }) {
    this.selectedFilter = item.dataset.filter;
    this.filterButtonTargets.forEach(button => {
      button.classList.remove('active');
    });
    item.classList.add('active');
    this.filterStories();
  }

  filterStories() {
    let allStories = document.querySelectorAll('[data-categories]');
    allStories.forEach(story => {
      story.classList.remove('show');
    });
    let stories = document.querySelectorAll(`[data-categories*="'${this.selectedFilter}'"]`);
    stories.forEach(story => {
      story.classList.add('show');
    });
    this.totalCountTarget.innerText = stories.length;
  }

}